import { useEffect, useState } from "react";
import { Modal } from "antd";
import { useDispatch } from "react-redux";
import "./forceLogout.css";

const ForceLogoutModal = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("FORCE_LOGOUT", handler);
    return () => window.removeEventListener("FORCE_LOGOUT", handler);
  }, []);

  const handleOk = () => {
    setOpen(false);
    dispatch({ type: "LOGOUT_USER_SUCCESS" });
    localStorage.clear();
    window.location.href = process.env.REACT_APP_HOME_URL;
  };

  return (
    <Modal
      open={open}
      onOk={handleOk}
      closable={false}
      okText="OK"
      title="Session Expired"
      centered
      footer={(_, { OkBtn }) => <OkBtn />}
      className="force-logout-modal"
    >
      <p>Your session has expired.</p>
      <p>Click OK to go back to the Login screen.</p>
    </Modal>
  );
};

export default ForceLogoutModal;
